import React from 'react';

export default ({ children, id }) => (
    <div id={`accordion${id}`} className="collapse-div accordion-custom" role="tablist">
        {children}
    </div>
);



